var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 10.0002C1.66699 9.55814 1.84259 9.13421 2.15515 8.82165C2.46771 8.50909 2.89163 8.3335 3.33366 8.3335C3.77569 8.3335 4.19961 8.50909 4.51217 8.82165C4.82473 9.13421 5.00033 9.55814 5.00033 10.0002C5.00033 10.4422 4.82473 10.8661 4.51217 11.1787C4.19961 11.4912 3.77569 11.6668 3.33366 11.6668C2.89163 11.6668 2.46771 11.4912 2.15515 11.1787C1.84259 10.8661 1.66699 10.4422 1.66699 10.0002Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33301 10.0002C8.33301 9.55814 8.5086 9.13421 8.82116 8.82165C9.13372 8.50909 9.55765 8.3335 9.99967 8.3335C10.4417 8.3335 10.8656 8.50909 11.1782 8.82165C11.4907 9.13421 11.6663 9.55814 11.6663 10.0002C11.6663 10.4422 11.4907 10.8661 11.1782 11.1787C10.8656 11.4912 10.4417 11.6668 9.99967 11.6668C9.55765 11.6668 9.13372 11.4912 8.82116 11.1787C8.5086 10.8661 8.33301 10.4422 8.33301 10.0002Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.99992C15 9.55789 15.1756 9.13397 15.4882 8.82141C15.8007 8.50885 16.2246 8.33325 16.6667 8.33325C17.1087 8.33325 17.5326 8.50885 17.8452 8.82141C18.1577 9.13397 18.3333 9.55789 18.3333 9.99992C18.3333 10.4419 18.1577 10.8659 17.8452 11.1784C17.5326 11.491 17.1087 11.6666 16.6667 11.6666C16.2246 11.6666 15.8007 11.491 15.4882 11.1784C15.1756 10.8659 15 10.4419 15 9.99992Z",
    fill: "#FFFFFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.80c04810a70cf3079de12d37a754c5ae.svg";
export { ForwardRef as ReactComponent };